<template>
  <div class="decks">
    <h3 class="has-text-left flashcard-deck-title">
      <slot v-if="isPrivate">My Decks</slot>
      <slot v-else>Decks created by educators</slot>
    </h3>
    <div v-if="flashcardDecksFiltered.length > 0 ">
      <div class="flashcard-deck-table">
        <div v-for="(flashcardDeck) in flashcardDecksFiltered" :key="flashcardDeck._id" class="tr">
          <div class="td">
            <div>{{ utils.truncateString(flashcardDeck.title, 12) }}</div>
            <InLocations
              v-if="flashcardDeckAttachmentsByResourceId[flashcardDeck._id]"
              v-bind="{bookMetadata, book, onCurrentPageChanged, close}"
              :resource="flashcardDeck"
              :attachments="flashcardDeckAttachmentsByResourceId[flashcardDeck._id]"
            />
          </div>
          <div @click="openResource(flashcardDeck)" class="icon-td no-select">
            <i class="fal fa-play"></i>
            <span class="small-text">Play</span>
          </div>
          <div v-if="isPrivate" @click="editFlashcardDeck(flashcardDeck)" class="icon-td no-select">
            <i class="fal fa-pencil"></i>
            <span class="small-text">Edit</span>
          </div>
          <Popover
            v-if="isPrivate"
            class="icon-td"
            ref="removeFlashcardDeck"
            placement="bottom"
            :width="270"
          >
            <div @click=";" class="no-select">
              <i class="fal fa-trash-alt"></i>
              <span class="small-text">Delete</span>
            </div>
            <div slot="content">
              <div class="delete-message">Permanently delete this deck?</div>
              <div class="popover-buttons">
                <button v-on:click.stop="closeDeletePopover()" class="button is-primary">No</button>
                <button
                  v-on:click.stop="deleteFlashcardDeck(flashcardDeck)"
                  class="button is-pulled-right"
                >Yes</button>
              </div>
            </div>
          </Popover>
        </div>
      </div>
    </div>
    <div v-else class="has-text-left deck-empty">
      <slot v-if="search.length <= 0">
        <slot
          v-if="isPrivate"
        >You currently don't have any user generated flashcard decks for this book.</slot>
        <slot v-else>You currently don't have any pushed flashcard decks for this book.</slot>
      </slot>
      <slot v-else>
        <slot v-if="isPrivate">No personal decks found for the entered search term.</slot>
        <slot v-else>No pushed decks found for the entered search term.</slot>
      </slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import utils from "@/utils/utils.js";
import serverUtils from "@/utils/serverUtils.js";
import storeHelpers from "@/utils/storeHelpers.js";
import analytics from "@/utils/analytics.js";
import Popover from "@/components/widgets/popover";
import Search from "@/components/widgets/Search";
import InLocations from "@/components/widgets/InLocations";

export default {
  name: "FlashcardDeckListItems",
  components: {
    Search,
    Popover,
    InLocations
  },
  props: {
    book: {
      type: Object,
      required: true
    },
    flashcardDecks: {
      type: Array,
      required: true
    },
    flashcardDeckAttachmentsByResourceId: {
      type: Object,
      required: true
    },
    isPrivate: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    bookMetadata: {
      type: Object
    },
    onCurrentPageChanged: {
      type: Function
    }
  },
  data: function() {
    var t = this;
    return {
      utils: utils
    };
  },
  mounted() {},
  computed: {
    flashcardDecksFiltered() {
      var t = this;
      var a = t.flashcardDecks.filter(deck => {
        return (
          deck.title.toLowerCase().includes(t.search.toLowerCase()) &&
          t.isPrivate === deck.private
        );
      });

      return _.sortBy(a, [
        function(deck) {
          return deck.title.toLowerCase();
        }
      ]);
    }
  },
  methods: {
    close: function() {
      this.$parent.$emit("closeFlashcardDeckList");
    },
    locations(flashcardDeck) {
      return this.flashcardDeckAttachmentsByResourceId[flashcardDeck._id]
        ? this.flashcardDeckAttachmentsByResourceId[flashcardDeck._id]
        : [];
    },
    closeDeletePopover: function() {
      var t = this;
      if (
        t.$refs.removeFlashcardDeck &&
        t.$refs.removeFlashcardDeck.length > 0
      ) {
        _.each(t.$refs.removeFlashcardDeck, function(ref) {
          ref.hidePopper();
        });
      }
    },
    openResource: function(resource) {
      utils.openResource(this, resource);
    },
    editFlashcardDeck: function(flashcardDeck) {
      var t = this;
      var deckData = {};
      utils.openFlashcardDeckById(this, flashcardDeck._id, function(res) {
        deckData.currentFlashcardDeckId = flashcardDeck._id;
        deckData.flashcardDeckObject = res.data;
        deckData.currentFlashcardDeckTitle = flashcardDeck.title;
        deckData.flashcardDeckEditor = true;
        t.$parent.$emit("getFlashcardDeck", deckData);
      });
    },
    deleteFlashcardDeck: function(resource) {
      var t = this;
      serverUtils.deleteResourceWithAttachments(t, resource._id);
      t.closeDeletePopover();
      storeHelpers.removeResource(t, resource);
      // flashcardDeck: function(handle, resourceId, action = 0)
      analytics.flashcardDeck(t, resource._id, 0);
    },
    locationsClicked(flashcardDeck) {},
    openLocation: function(attachment) {
      t.close();

      if (attachment) {
        var pageNumber = atts[0].section; // todo lookup page number
        t.$parent.$emit("openLocation", pageNumber);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

h3 {
  display: block;
  font-size: 1.17em;
  margin-left: 0;
  margin-right: 0;
  font-weight: bold;
}

.deck-empty {
  color: $light-font-color;
  padding-bottom: 10px;
  margin: 0 10px 0 10px;
}

.modal {
  overflow-y: hidden;
  z-index: 600 !important;
  .modal-content {
    width: 450px;
    margin: 80px auto;
    .flashcard-deck-title {
      margin: -3px 10px 0 10px;
      border-bottom: 1px solid $border-color;
      height: 37px;
      position: -webkit-sticky;
      position: -moz-sticky;
      position: -ms-sticky;
      position: -o-sticky;
      position: sticky;
      top: 152px;
      background: white;
    }
    .flashcard-deck-table {
      display: table;
      width: 95%;
      margin: 0 auto;

      .tr {
        display: table-row;
        .td {
          text-align: left;
          display: table-cell;
          padding: 10px;
          max-width: 100px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

          .in-locations {
            color: $primary-color;
            font-size: 11pt;
          }

          .in-locations:hover {
            color: $background-color-darkest;
            text-decoration: underline;
            cursor: pointer;
          }
        }
        .icon-td {
          display: table-cell;
          width: 60px;
          padding: 10px;
          font-size: 23px !important;
          .small-text {
            display: block;
            font-size: 12px;
          }
        }
        .icon-td:hover {
          background: $background-color-darker1;
          cursor: pointer;
        }
        .icon-td:active {
          background: $background-color-darker2;
        }
      }
      .tr:hover {
        background: $background-color-dark;
      }
    }
  }
  .close-button {
    margin-top: 20px;
  }
}

.popover-buttons {
  margin-top: 10px;
}

.delete-message {
  text-align: center;
}

@media screen and (min-device-width: 300px) and (max-device-width: 499px) {
  .modal .modal-content {
    width: 90vw;
    margin: 20% auto;
  }
}
</style>
